export default function LegalDocSection({
  heading,
  index,
  body
}: {
  heading: string
  index: number
  body: string | JSX.Element
}) {
  return (
    <div className="mb-8">
      <h2 className="text-xl font-mulish-bold">
        {index + 1}. {heading}
      </h2>
      <p>{body}</p>
    </div>
  )
}
